import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Nav from "../components/nav"
import Github from "../components/svgs/github"
import Twitter from "../components/svgs/twitter"
import LinkedIn from "../components/svgs/linkedin"
import Img from "gatsby-image"

export default class About extends React.Component {

  state = { 
    isTransparent: true 
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  };

  handleScroll = () => {
    const main = document.querySelector(".page--about__main");
    if (main) {
      if (main.getBoundingClientRect().top <= 70) {
        this.setState({ isTransparent: false });
      } else {
        this.setState({ isTransparent: true });
      }
    }
  };

  render() {
    return (
      <Layout>
        <SEO title="About" />
        <div className="page page--about">
          <div className="page--about__hero">
            <div className="page--about__intro">
              <div className="page--about__text">
                <h1>
                  <span>Hey there.</span>
                  I'm an Engineer from India
                </h1>
                <div className="page--about__underline" />
                <h2>
                  While I'm down to learn pretty much anything, I'm happiest
                  working at the intersection of design and engineering, where I
                  can focus on creative problem-solving and elegant UI.
                </h2>
              </div>
              <div className="page--about__photo">
                <Img fluid={this.props.data.file.childImageSharp.fluid} />
              </div>
            </div>
          </div>
          <Nav {...this.state} />
          <div className="page--about__main">
            <div className="page--about__wrap">
              <div className="page--about__bio">
                <h1>About Me</h1>
                <h3>Say Hello</h3>
                <div className="page--about__social">
                  <a href="https://github.com/bearbobs" target="_blank">
                    <Github />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/anuj-kapoor-642387158/"
                    target="_blank"
                  >
                    <LinkedIn />
                  </a>
                  <a href="https://twitter.com/AnujKaps" target="_blank">
                    <Twitter />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export const query = graphql`
  query {
    file(relativePath: { eq: "anujkapoor.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`